import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Center, Flex, Icon } from '@chakra-ui/react';
import { NotificationTime } from '../../components/Time';
import {
  ConfirmRSVPButtons,
  MeetingDetailsContainer,
  NotificationMessage,
  ReviewCandidateButton,
  InterviewActionButtons,
} from './components';
import { Calendar } from '@kula-ai/icons/dual-tone/Calendar';
import { Hackerrank } from '@/assets/icons/ats';

const InterviewBooked = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  const {
    candidate,
    interview_name,
    interview_url,
    job_name,
    interview_location_enum,
    meeting_link,
    is_mscal_shared_calendar,
  } = data;

  const { name: candidateName, url } = candidate;
  const contact_id = url.split('/').pop();
  const interview_id = interview_url.split('/').pop();

  const messageData = {
    interview: { name: interview_name, url: `/interviews/${interview_id}` },
    candidate: { name: candidateName, url: `/candidates/${contact_id}` },
    job: { name: job_name },
    interview_location_enum: interview_location_enum,
  };
  return (
    <Flex alignItems="baseline" gap="6px">
      <Center
        minW="34px"
        h="34px"
        borderRadius="sm"
        bg={
          interview_location_enum === 'hackerrank' ? 'black' : 'pastel-2-light'
        }
      >
        {interview_location_enum === 'hackerrank' ? (
          <Icon as={Hackerrank} color="ats-primary" />
        ) : (
          <Icon as={Calendar} color="pastel-2-dark" width="16px" />
        )}
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <NotificationMessage
          template="INTERVIEW_BOOKED"
          data={messageData}
          onClose={onClose}
          notification={notification}
        />
        <MeetingDetailsContainer data={data} />
        {interview_location_enum !== 'hackerrank' && (
          <Flex flexDir="column" gap="6px">
            {!is_mscal_shared_calendar && (
              <>
                <ConfirmRSVPButtons
                  notification={notification}
                  interviewUrl={interview_url}
                />
                <ReviewCandidateButton
                  interviewUrl={interview_url}
                  notification={notification}
                />
              </>
            )}
            {is_mscal_shared_calendar && (
              <InterviewActionButtons
                interviewUrl={interview_url}
                meetingLink={meeting_link}
                notification={notification}
              />
            )}
          </Flex>
        )}
        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const InterviewBookedNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <InterviewBooked notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
